import React from "react";

export default function useMessage(actionType, callback, deps) {
  const onCallback = React.useCallback(callback, deps);
  const eventCallback = React.useCallback(
    (e) => {
      const { type, data } = e.data;
      if (type === actionType) {
        onCallback(data);
      }
    },
    [actionType, onCallback]
  );
  React.useEffect(() => {
    window.addEventListener("message", eventCallback);
    return () => {
      window.removeEventListener("message", eventCallback);
    };
  }, [eventCallback]);
}

export function postMessage(actionType, data) {
  window.parent.postMessage(
    {
      type: actionType,
      data,
    },
    "*"
  );
}
